import React from "react";

import {
	IGenericHistoryType
} from "./GameHistoryTypes";

export interface IRoadmapLargeProps {
	pcode: string;
	history: IGenericHistoryType[];
	historyBlink: boolean;
	filter: string;
    // langdata: ILanguageType;

	//Desktop
    showLobbyGameGroup?: boolean;
    lobbyDesktop?: boolean;
	small?: boolean;
	enlarged?: boolean;

	type?: string;
	baccaratDarkMode?: boolean;

    //Mobile
    mobile?: boolean;
    lobbyMobile?: boolean;
	orientation?: string;
	
	expanded?: boolean;

	//Only for NiuNiu
	niuNiuResult?: any;
}

export class IRoadmapLargeClass extends React.Component<IRoadmapLargeProps> {
	firstDisplayedCol: number;
}